import React, { Component } from 'react';
import authService from './../api-authorization/AuthorizeService'
import { ConfigMenu } from './../ConfigMenu'
import { FormattedMessage } from 'react-intl';
import Popup from './../popup/reactjs-popup.cjs.development';
import { Contacts } from '@capacitor-community/contacts';
import { Capacitor } from '@capacitor/core';
import { CallNumber } from 'capacitor-call-number';

export class ChartUser extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    this.state = {
      report: [],
      userreport: [],
      loading: true,
      date: curDate,
      alltime: false,
      contacts: [],
      companyId: parseInt(this.props.match.params.companyId) || 0
    };
  }

  async componentDidMount() {
    this.populateCompaniesData();
    await this.loadContacts();
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/companies/admin`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data}));
    if (this.state.companies.length > 0)
    {
      const ownCompanies = this.state.companies.filter(c => this.state.companyId === 0 || c.id === this.state.companyId);
      if (ownCompanies.length > 0) {
        this.setState(prevState => ({...prevState, companyId: ownCompanies[0].id}));
        this.populateMonthData(ownCompanies[0].id, this.state.date);
      } else {
        window.location.replace(`/configcompany/${this.state.companyId}`);
      }
    }
  }

  allTime(choose) {
    this.setState(prevState => ({...prevState, alltime: choose}));
    this.populateMonthData(this.state.companyId, this.state.date);
  }

  prevMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() - 1);
    this.setState(prevState => ({...prevState, date: date, alltime: false}));
    this.populateMonthData(this.state.companyId, this.state.date);
  }

  nextMonth() {
    var date = this.state.date;
    date.setMonth(this.state.date.getMonth() + 1);
    this.setState(prevState => ({...prevState, date: date, alltime: false}));
    this.populateMonthData(this.state.companyId, this.state.date);
  }

  async onOpenPopup(userId, month) {
    this.setState(prevState => ({...prevState, userreport: []}));
    const token = await authService.getAccessToken();
    var query = `{{mainApiUrl}}api/report/${this.state.companyId}/userreport/${userId}`;
    if (!this.state.alltime) {
      query += `?month=${month.toLocaleDateString('en-US')}`;
    }
    const response = await fetch(query, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, userreport: data, loading: false}));
  }

  async call(phoneNumber) {
    try {
      await CallNumber.call({ number: phoneNumber, bypassAppChooser: false });
    } catch (error) {
      console.log(error);
    }
  }

  async loadContacts() {
    if (this.state.contacts && this.state.contacts.length > 0) {
      return;
    }
    this.setState(prevState => ({...prevState, loadingContacts: true }));
   
    try {
      var permissionResult;
      if (Capacitor.getPlatform() === 'web') {
        permissionResult = await navigator.permissions.query({name: 'contacts'});
      } else {
        permissionResult = await Contacts.requestPermissions();
      }
     
      console.log(permissionResult);
      if (permissionResult.granted || permissionResult.contacts === 'granted' || permissionResult.state === 'granted') {
        const result = await Contacts.getContacts({projection:{name:true,phones:true}});
        this.setState(prevState => ({...prevState, contacts: result.contacts.filter(c => c.phones?.length > 0 && c.name?.display?.length > 0).map(c => ({value: c.phones[0].number.replaceAll(" ","").replaceAll("-","").replaceAll("(","").replaceAll(")",""), label: c.name.display})) }));
        console.log('Contacts loaded:', result.contacts.length);
        console.log('Contacts loaded:', result.contacts);
      } else {
      }
    } catch (error) {
      console.error('Contacts error:', error);
    } finally {
      this.setState(prevState => ({...prevState, loadingContacts: false }));
    }
  }

  renderUserOrders() {
    return (
      <div>

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th><FormattedMessage id="service"/></th>
            <th><FormattedMessage id="date"/></th>
            <th><FormattedMessage id="time"/></th>
            <th><FormattedMessage id="price"/></th>
            <th><FormattedMessage id="resource"/></th>
          </tr>
        </thead>
        <tbody>
          {this.state.userreport.map(user =>
            <tr key={user.day}>
              <td>{user.service}</td>
              <td>{new Date(user.date).toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit'/*, hour: "2-digit", minute: "2-digit"*/})}</td>
              <td>{Math.floor(user.start/100)}:{(user.start%100).toString().padStart(2, '0')}</td>
              <td>{user.price}</td>
              <td>{user.resource}</td>
            </tr>
          )}
        </tbody>
      </table>

      </div>
    );
  }

  renderReportTable() {
    var date = this.state.date;
    return (
      <div>

      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th width="16px" onClick={() => this.allTime(true)} style={{cursor: "pointer"}} className={this.state.alltime?'react-calendar__tile--active':''}><FormattedMessage id="all_time"/></th>
            <th><FormattedMessage id="customer"/></th>
            <th width="16px" onClick={() => this.prevMonth()} style={{cursor: "pointer"}}>&lt;</th>
            <th onClick={() => this.allTime(false)} style={{cursor: "pointer"}} className={this.state.alltime?'':'react-calendar__tile--active'}>{date.toLocaleString(undefined, {month: '2-digit', year: 'numeric'})}</th>
            <th width="16px" onClick={() => this.nextMonth()} style={{cursor: "pointer"}}>&gt;</th>
            <th><FormattedMessage id="first_visit"/></th>
            <th><FormattedMessage id="last_visit"/></th>
            <th><FormattedMessage id="count_visit"/></th>
            <th><FormattedMessage id="phone"/></th>
          </tr>
        </thead>
        <tbody>
          {this.state.report.map(user => {
            const contact = this.state.contacts.filter(c => c.value == user.phone)[0];
            return <tr key={user.day}>
              <Popup ref={this.selectorRef}
                    className="popup-info"
                    onOpen={() => this.onOpenPopup(user.id, this.state.date)}
                    trigger={open => <td colspan="2"><a href="#" onClick={(e) => e.preventDefault()}>{user.name}</a></td>}
                    position="bottom center"
                    closeOnDocumentClick>{() => this.renderUserOrders()}</Popup>
              <td colspan="3">{user.value}</td>
              <td>{new Date(user.first).toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit"})}</td>
              <td>{new Date(user.last).toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit"})}</td>
              <td>{user.count}</td>
              <td>
            {!contact ? (Capacitor.isNativePlatform() ? <div><a class="aphone" onClick={() => this.call(user.phone)}>{user.phone}</a> <div className="btnaddcontact" id="Button_AddContact" onClick={() => this.addContact(user.phone, user.name)}></div></div> : <div><a class="aphone" href={`tel:${user.phone}`}>{user.phone}</a></div>) :
            <div title={user.phone} className="btncontact" id="Button_Contact" onClick={() => this.call(user.phone)}>{contact.label}</div>}

              </td>
            </tr>;}
          )}
        </tbody>
      </table>

      </div>
    );
  }

  render() {
    let contents = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderReportTable();

    return (
      <div class="sidenav-container-div">
        <ConfigMenu {...this.props} companyId={this.state.companyId} selected="charts" />
        <div class="headerdiv"><h4 id="tabelLabel"><FormattedMessage id="user_chart_page"/></h4></div>
        {contents}
      </div>
    );
  }

  async populateMonthData(companyId, month) {
    const token = await authService.getAccessToken();
    var query = `{{mainApiUrl}}api/report/${companyId}/userreport`;
    if (!this.state.alltime) {
      query += `?month=${month.toLocaleDateString('en-US')}`;
    }
    const response = await fetch(query, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, report: data, loading: false}));
  }
}
